// import { useState } from 'react'
import { Modal } from 'reactstrap';
// import { Spinner } from 'src/components/Common/Spinner';
import { IReportedMessage } from 'src/services/types';

interface IProps {
    show: boolean;
    onClose: () => void;
    item: IReportedMessage;
} 
export const DetailsReportMessageModal = ({ show, onClose, item }: IProps) => {
    // const [loading, setLoading] = useState(false);

    const formatDateTime = (dateTime: string) =>{
        if(!dateTime) return '-'
        const date = new Date(dateTime);
    
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        
        return `${month}-${day}-${year} ${hours}:${minutes}`; 
    }

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
    >
        {/* {
            loading ? 
                <div className='d-flex justify-content-center align-items-center' style={{height: '200px'}}>
                    <Spinner text='Loading user...'/>
                </div>
            : ( */}
                <>
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">
                            Detail of the reported message
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>User:</h6>
                                            <div className='mb-4 d-flex justify-content-center align-items-center'>
                                                <img 
                                                    src={item?.user?.imagePath} 
                                                    alt="" 
                                                    className='rounded-3 img-fluid'
                                                    style={{cursor: 'pointer'}}                                            
                                                    width={120} 
                                                />
                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>Full Name:</h6>
                                            <p>{item?.user?.firstName} {item?.user?.lastName}</p>
                                        </div>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>Email:</h6>
                                            <p>{item?.user?.email}</p>
                                        </div>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>User Type:</h6>
                                            <p>{item?.user?.userType}</p>
                                        </div>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>Goal:</h6>
                                            <p>{item?.user?.goal}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>Reported User:</h6>
                                            <div className='mb-4 d-flex justify-content-center align-items-center'>
                                                <img 
                                                    src={item?.userReported?.imagePath} 
                                                    alt="" 
                                                    className='rounded-3 img-fluid'
                                                    style={{cursor: 'pointer'}}                                            
                                                    width={120} 
                                                />
                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>Full Name:</h6>
                                            <p>{item?.userReported?.firstName} {item?.userReported?.lastName}</p>
                                        </div>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>Email:</h6>
                                            <p>{item?.userReported?.email}</p>
                                        </div>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>User Type:</h6>
                                            <p>{item?.userReported?.userType}</p>
                                        </div>
                                        <div className='col-12'>
                                            <h6 className='text-primary'>Goal:</h6>
                                            <p>{item?.userReported?.goal}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='pt-3' style={{borderTop: '1px solid #e9e9ef'}}>
                                <h6 className='text-primary'>Reason:</h6>
                                <p>{item.reason}</p>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='pt-3' style={{borderTop: '1px solid #e9e9ef'}}>
                                <h6 className='text-primary'>Reported Message:</h6>
                                <p>{item.message}</p>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='pt-3' style={{borderTop: '1px solid #e9e9ef'}}>
                                <h6 className='text-primary'>Created at:</h6>
                                <p>{formatDateTime(item.createdAt)}</p>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={onClose}>
                            Ok
                        </button>
                    </div>
                </>
            {/* )
        } */}
       
    </Modal>
  )
}
